<template>
  <div class="container-fluid">
    <div data-widget-group="group1">
      <ol class="breadcrumb">
        <li>
          <router-link to="/admin">Dashboard</router-link>
        </li>
        <li class="active">
          Report Product Coupons Details
        </li>
      </ol>
      <div class="row">
        <div class="col-md-3">
          <div id="search-box">
            <div class="form-group">
               <label for="searchbox">Search</label>
              <input
                type="text"
                class="search-query form-control"
                placeholder="Search Part Number"
                v-model="searchText"
                name="searchbox"
              />
            </div>
          </div>
        </div>      
        <div class="col-md-3">
          <div class="form-group">
            <label for="from">From Month</label>
          <datepicker :minimumView="'month'"   :name="'from'" :maximumView="'year'" :initialView="'year'" :bootstrapStyling="true" @selected="fromDateSelect" ></datepicker>
          </div>
        </div>
         <div class="col-md-3">
          <div class="form-group">
            <label for="To">To Month</label>
          <datepicker :minimumView="'month'" :value="newLastMonthDate"  :name="'To'" :maximumView="'year'" :initialView="'year'" :bootstrapStyling="true" @selected="toDateSelect" ></datepicker>
          </div>
        </div>
         <div class="col-md-3">
          <div class="form-group">
            <label for="To">Partner Type</label>
          <v-select v-model="PartnerTypeSelected" :options="PartnerOptions" :reduce="partnerDetails => partnerDetails.code" label="name" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 col-md-offset-7">
          <div class="form-group">
            <button
              type="button"
              v-on:click="getAllCoupons(1)"
              class="btn btn-raised btn-primary submitbtn"
            >
              Filter
            </button>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <button
              type="button"
              v-on:click="exportReport(0)"
              class="btn btn-raised btn-primary submitbtn"
            >
              Export To CSV
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">

        <button type="button" class="btn btn-default">Total Coupons <span class="badge"> {{TotalCoupon}}</span></button>
        <button type="button" class="btn btn-default">Marry Coupons <span class="badge"> {{AvailableCoupon}}</span></button>
        <button type="button" class="btn btn-default">New Generated Coupons <span class="badge"> {{GeneratedCoupon}}</span></button>

        </div>
        <div class="col-md-12">
          <div class="panel panel-default visibility" id="panel-inline">
            <div class="panel-heading">
              <div class="panel-ctrls"></div>
            </div>
            <div class="panel-body no-padding visibility">
              <table
                class="table table-striped table-bordered"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Coupon ID</th>
                    <td>Serial Number</td>
                    <td>Product Name</td>
                    <th>Points</th>
                    <th>Reborer Status</th>
                    <th>Mechanic Status</th>
                    <th>Grinder Status</th>
                    <th>Grinder Reborer Status</th>
                    <th>Retailer Status</th>
                    <th>Updation Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in coupon_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    <td class="left-align">
                      <!-- <router-link
                        :to="{
                          name: 'editReborer',
                          params: { partner_id: item.id },
                        }"
                        ></router-link
                      > -->
                      {{ item.coupon }}
                    </td>
                    <td>{{ item.serial_number }}</td>
                    <td>{{ item.ProductName }}</td>
                    <td>{{ item.points }}</td>
                    <td>{{ item.ReborerStatus }}</td>
                    <td>{{ item.MechanicStatus }}</td>
                    <td>{{ item.GrinderStatus }}</td>
                    <td>{{ item.GrinderReborerStatus }}</td>
                    <td>{{ item.RetailerStatus }}</td>
                    <td>{{ item.modified_date ? item.modified_date : item.created_date | dateFormatReadable }}</td>
                  </tr>
                </tbody>
              </table>
              <!--end table-->
            </div>
            <div class="panel-footer">
              <paginate
                :page-count="TotalPage"
                :click-handler="getAllCoupons"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div id="externalScript"></div> -->
  </div>
</template>
<script>
import Paginate from 'vuejs-paginate';
import commonServices from '../../services/common-services';
import Datepicker from 'vuejs-datepicker';
import DateLanguages from '../components/utils/DateLanguages';
import moment from 'moment'
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
export default {
  name: 'couponMaster',
  data() {
    return {
       
      isActive:false,
      ReborerCheck: false,
      coupon_data: [],
      searchText: '',
      page: 1,
      pageSize: 10,
      TotalPage: 1,
      currentPage: 1,
      message:'',
      AvailableCoupon:0,
      GeneratedCoupon:0,
      TotalCoupon:0,
      newLastMonthDate:'',
      PartnerOptions: [
      {code: 'Retailer','name':'Retailer'},
      {code: 'Reborer','name':'Reborer'},
      {code: 'Grinder','name':'Grinder'},
      {code: 'ReborerPlusGrinder','name':'Reborer Plus Grinder'},
      {code: 'Mechanics','name':'Mechanics'},
      ],
      PartnerTypeSelected:''
    };
  },
  components: {
    Paginate,
    Datepicker,
    DateLanguages,
    vSelect
  },
  computed:{
   
  },
  methods: {
    fromDateSelect(date){
      this.fromMonthYear =date
    },
    toDateSelect(date){
      this.newLastMonthDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.toMonthYear =this.newLastMonthDate;
    },
    getRequestParams(searchText, page, pageSize) {
      let params = {};
      if(this.PartnerTypeSelected){
         params['PartnerTypeSelected'] = this.PartnerTypeSelected;
      }
      if (this.fromMonthYear) {
        params['fromMonthYear'] = this.fromMonthYear;
      }
      if (this.toMonthYear) {
        params['toMonthYear'] = this.toMonthYear;
      }
      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }

      return params;
    },
    exportReport(pageNum){
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      /*bajajAPI/user/list*/
      commonServices
        .get('kspgAPI/Coupon/productListReportExport', params)
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'file.csv');
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((e) => {
           if(e.response.data.error == "Invalid API key "){
             loader.hide()
             this.$router.push({ name: 'login'});
          }
        });
      setTimeout(() => {loader.hide()}, 1000)
    },
    getAllCoupons(pageNum) {
      this.skyloStart();
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      /*bajajAPI/user/list*/
      commonServices
        .get('kspgAPI/Coupon/productListReport', params)
        .then((response) => {
          const {
            coupon_data,
            totalItems,
            currentPage,
            TotalPage,
            AvailableCoupon,
            GeneratedCoupon,
            TotalCoupon
          } = response.data;
          this.coupon_data = coupon_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
          this.AvailableCoupon =  AvailableCoupon;
          this.GeneratedCoupon =   GeneratedCoupon;
          this.TotalCoupon = TotalCoupon;
        })
        .catch((e) => {
           if(e.response.data.error == "Invalid API key "){
             loader.hide()
             this.$router.push({ name: 'login'});
          }
        });
      this.skyloEnd();
      setTimeout(() => {loader.hide()}, 1000)
    },
  
  },
  mounted() {
    this.getAllCoupons(1);
  },
  filters: {
    dateFormatReadable(input_date) {
      if (!input_date) {
        return input_date;
      }
      return moment(String(input_date)).format('DD-MM-YYYY');
    },
  },
};
</script>
<style scoped>
.visibility {
  visibility: visible !important;
}
.search-button {
  background-color: #555555;
  color: #ffffff;
}
.left-align{
    text-align: left !important;
}
</style>